import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Grid, GridProps } from '@mui/material'

import { GRTooltip } from '../GRTooltip/GRTooltip'
import { LockedData } from '../LockedData/LockedData'
import './LockedFeatureIndicator.scss'

/**
 * Component for a simple text indicator telling that a feature is locked
 */

type LockedFeatureIndicatorProps = GridProps & {}

export const LockedFeatureIndicator: FC<LockedFeatureIndicatorProps> = ({ ...gridProps }) => {
  const { t } = useTranslation()

  return (
    <Grid container alignItems="center" columnGap={1} {...gridProps} className="LockedFeatureIndicator">
      <Grid item>
        <LockedData />
      </Grid>
      <Grid item className="LockedFeatureIndicator__features">
        <GRTooltip content={t('feature:upgrade_your_plan_to_unlock_this_feature')}>{t('feature:upgrade_your_plan_to_unlock_this_feature')}</GRTooltip>
      </Grid>
    </Grid>
  )
}
